// Arrow carousel for the custom home sections.
// Delegated from the document: the theme re-renders sections after load, which
// would drop listeners bound to the original buttons.
(function () {
  function track(wrap) { return wrap.querySelector('[data-carousel-track]'); }

  function step(t) {
    var card = t.firstElementChild;
    var gap = parseFloat(getComputedStyle(t).columnGap) || 0;
    return card ? card.offsetWidth + gap : t.clientWidth;
  }

  function sync(wrap) {
    var t = track(wrap);
    if (!t) return;
    var max = t.scrollWidth - t.clientWidth;
    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (prev) prev.hidden = max < 2 || t.scrollLeft <= 1;
    if (next) next.hidden = max < 2 || t.scrollLeft >= max - 1;
  }

  function syncAll() { document.querySelectorAll('[data-carousel]').forEach(sync); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var wrap = btn.closest('[data-carousel]');
    var t = wrap && track(wrap);
    if (!t) return;
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    t.scrollBy({ left: dir * step(t), behavior: 'smooth' });
  });

  // scroll does not bubble, so listen in the capture phase
  document.addEventListener('scroll', function (e) {
    var wrap = e.target.closest && e.target.closest('[data-carousel]');
    if (wrap) sync(wrap);
  }, true);

  // Lazy images finish after window load and do not mutate the DOM, so the
  // observer below never fires for them - without this the arrows stay hidden
  // on a row whose cards were still empty at first sync.
  addEventListener('load', function () { syncAll(); }, true);

  addEventListener('resize', syncAll);
  addEventListener('load', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  // Sections re-render and images settle after first paint; re-check then
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(syncAll, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  syncAll();
})();
